export default __webpack_public_path__ + "static/media/KolkataLineUp.33af615f.svg";